import React from "react";
import styled from "styled-components";

import PlayerManager from "../../../service/player-manager";
import { DEFAULT_YT_VIDEO_ID } from "../../../config";
import { Box } from "../../../comps";

const IFrameWrapper = styled(Box)`
  width: 100%;
  height: 100%;
`;

const ID = "vjf";

class YouTubeVideo extends React.Component {
  constructor() {
    super();
    this.state = { hovered: false };
  }
  componentDidMount = () => {
    // On mount, check to see if the API script is already loaded
    if (!window.YT) {
      // If not, load the script asynchronously
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";

      // onYouTubeIframeAPIReady will load the video after the script is loaded
      window.onYouTubeIframeAPIReady = this.loadVideo;

      const firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    } else {
      // If script is already there, load the video directly
      this.loadVideo();
    }
  };

  loadVideo = () => {
    // the Player object is created uniquely based on the id
    this.player = new window.YT.Player(`youtube-player-${ID}`, {
      videoId: DEFAULT_YT_VIDEO_ID,
      // set autoplay, so that we can play cued video
      playerVars: { autoplay: 0, controls: 0 },
      events: {
        onReady: this.onPlayerReady,
        onStateChange: this.onPlayerStateChange,
      },
    });
  };

  onPlayerStateChange = (event) => {
    PlayerManager.onVideoStateChange(event);
  };

  onPlayerReady = (event) => {
    PlayerManager.registerPlayer(event.target);
    // set width and height of iframe as its parent
    const p = document.getElementById(`youtube-player-${ID}`);
    if (p) {
      p.style.width = `100%`;
      p.style.height = `100%`;
    }
  };

  render = () => {
    return (
      <IFrameWrapper>
        <div id={`youtube-player-${ID}`} />
      </IFrameWrapper>
    );
  };
}

export default YouTubeVideo;
